import React, { memo } from 'react';
import { useSound } from '../contexts/SoundContext';

const LevelRating = memo(({ 
  value, 
  onChange, 
  maxLevels = 7, 
  disabled = false,
  label = ""
}) => {
  const { playInterfaceSelectionHover } = useSound();

  const handleLevelClick = (levelValue) => {
    if (!disabled && onChange) {
      playInterfaceSelectionHover();
      onChange(levelValue);
    }
  };

  const handleKeyDown = (event, levelValue) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleLevelClick(levelValue);
    }
  };

  return (
    <div className="flex flex-col items-center">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
          {label}
        </label>
      )}
      <div className="flex items-center space-x-1" role="radiogroup" aria-label={label}>
        {[...Array(maxLevels)].map((_, index) => {
          const levelValue = index + 1;
          const isSelected = levelValue === value;
          const isActive = !disabled;
          
          return (
            <button
              key={levelValue}
              type="button"
              className={`
                w-8 h-8 rounded-full border-2 transition-all duration-200 text-sm font-semibold
                ${isSelected 
                  ? 'bg-blue-600 border-blue-600 text-white dark:bg-[#FF5722] dark:border-[#FF5722]'
                  : 'bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-700 dark:text-gray-200 hover:border-blue-400 dark:hover:border-[#FF8A65]'
                } 
                ${isActive ? 'hover:scale-110 cursor-pointer' : 'cursor-default'}
                ${disabled ? 'opacity-50' : ''}
                focus:outline-none focus:ring-2 focus:ring-blue-400 dark:focus:ring-orange-glow focus:ring-offset-2
              `}
              onClick={() => handleLevelClick(levelValue)}
              onKeyDown={(e) => handleKeyDown(e, levelValue)}
              aria-label={`Level ${levelValue}`}
              aria-checked={isSelected}
              role="radio"
              tabIndex={disabled ? -1 : 0}
            >
              {levelValue}
            </button>
          );
        })}
      </div>
      <div className="text-sm text-gray-600 dark:text-gray-300 mt-1">
        Level {value}
      </div>
    </div>
  );
});

LevelRating.displayName = 'LevelRating';

export default LevelRating;
